import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./login.css";

export default function Loginpage() {
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (event) => {
        event.preventDefault();
        const email = document.getElementById("email").value;
        const password = document.getElementById("password").value;

        try {
            const response = await fetch("https://api.itrain.io/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email, password }),
            });

            if (response.ok) {
                const data = await response.json();

                if (data.role === "Admin") {
                    localStorage.setItem("userRole", "Admin");
                    localStorage.setItem("token", data.token);
                    localStorage.setItem("mail", email);
                    localStorage.setItem("name", data.adminName);
                    navigate("/admin");
                } else if (data.role === "Trainer") {
                    localStorage.setItem("userRole", "Trainer");
                    localStorage.setItem("mail", email);
                    localStorage.setItem(
                        "name",
                        data.trainer.firstName + " " + data.trainer.lastName
                    );
                    navigate("/trainer");
                } else if (data.role === "Student") {
                    localStorage.setItem("userRole", "Student");
                    localStorage.setItem("stdid", data.student._id);
                    localStorage.setItem("token", data.token);
                    localStorage.setItem("mail", email);
                    localStorage.setItem(
                        "name",
                        data.student.firstName + " " + data.student.lastName
                    );
                    localStorage.setItem("Id", data.student.Id);
                    navigate("/student");
                } else {
                    showToast("Invalid email or password.");
                }
                return;
            }

            showToast("Invalid email or password.");
        } catch (error) {
            showToast("An error occurred. Please try again.");
            console.error("Login error:", error);
        }
    };

    const showToast = (message) => {
        toast.error(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const [passwordVisible, setPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    return (
        <div>
            <ToastContainer />
            <section className="auth d-flex">
                <div className="auth-left bg-main-50 flex-center p-24">
                    <img src="assets/images/thumbs/auth-img1.png" alt="" />
                </div>
                <div className="auth-right px-24 flex-center flex-column">
                    <div className="auth-right__inner mx-auto w-100">
                        <a href="" className="auth-right__logo mb-3">
                            <img src="assets/images/logo/logo.png" alt="" />
                        </a>
                        <h2 className="mb-8">Welcome to iTrain</h2>
                        <p className="text-gray-600 text-15 mb-32">
                            Sign in to continue your journey
                        </p>
                        <form id="loginForm" onSubmit={handleLogin}>
                            <div className="mb-24">
                                <label htmlFor="fname" className="form-label mb-8 h6">
                                    Email
                                </label>
                                <div className="position-relative">
                                    <input
                                        type="email"
                                        className="form-control py-11 ps-40"
                                        id="email"
                                        placeholder="Email address"
                                        required
                                    />
                                    <span className="position-absolute top-50 translate-middle-y ms-16 text-gray-600 d-flex">
                                        <i className="ph ph-user" />
                                    </span>
                                </div>
                            </div>
                            <div className="mb-24">
                                <label htmlFor="current-password" className="form-label mb-8 h6">
                                    Password
                                </label>
                                <div className="position-relative">
                                    <input
                                        type={passwordVisible ? "text" : "password"}
                                        className="form-control py-11 ps-40"
                                        id="password"
                                        placeholder="Enter Password"
                                        required
                                    />
                                    <span
                                        className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y ph ${
                                            passwordVisible ? "ph-eye" : "ph-eye-slash"
                                        }`}
                                        onClick={togglePasswordVisibility}
                                        style={{ cursor: "pointer" }}
                                    />
                                    <span className="position-absolute top-50 translate-middle-y ms-16 text-gray-600 d-flex">
                                        <i className="ph ph-lock" />
                                    </span>
                                </div>
                            </div>
                            <div className="mb-32 flex-between flex-wrap gap-8">
                                <div className="form-check mb-0 flex-shrink-0" />
                                <a
                                    href=""
                                    className="text-main-600 hover-text-decoration-underline text-15 fw-medium"
                                >
                                    Forgot Password?
                                </a>
                            </div>
                            <button type="submit" className="btn btn-main rounded-pill w-100">
                                Sign In
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}
